// Project/domain icons are stored in the DB as a single `icon_url` string that
// doubles as either an emoji glyph (e.g. "🗓️") or an image path/URL
// (e.g. "/assets/calrn-icon-512.png"). This renders whichever form it is.

interface ProjectIconProps {
  icon: string | null | undefined;
  /** Tailwind text-size class used when the icon is an emoji glyph. */
  size: "text-4xl" | "text-5xl" | "text-6xl";
  /** Extra wrapper classes, typically margins (e.g. "mb-4"). */
  className?: string;
  /** Accessible label for image icons; ignored for emoji. */
  alt?: string;
}

// Pixel box for image icons, matched to the emoji size class it replaces.
const IMG_SIZE: Record<ProjectIconProps["size"], string> = {
  "text-4xl": "h-11 w-11",
  "text-5xl": "h-14 w-14",
  "text-6xl": "h-20 w-20",
};

export function isImageIcon(icon: string | null | undefined): boolean {
  return !!icon && /^(https?:\/\/|\/)/.test(icon);
}

export function ProjectIcon({ icon, size, className = "", alt = "" }: ProjectIconProps) {
  if (isImageIcon(icon)) {
    return (
      <img
        src={icon!}
        alt={alt}
        className={`${IMG_SIZE[size]} object-contain rounded-xl ${className}`}
      />
    );
  }
  return <div className={`${size} ${className}`}>{icon || "📦"}</div>;
}
